import { lazy } from "react";
const OrderManagement = lazy(() => import("@/pages/orderManagement/page"));

const orderRoute = [
  {
    path: "/orderManagement",
    name: "采购订单管理",
    component: OrderManagement,
  },
];
export default orderRoute;
